import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";

const COCHARGE_DIRECT_BASE_URL = process.env.REACT_APP_COCHARGE_DIRECT_BASE_URL;

export const ActionButtons: React.FC<{ stationId: string }> = ({
  stationId,
}) => {
  const navigate = useNavigate();

  if (!stationId) {
    console.error("StationId unavailabe");
    return <></>;
  }

  return (
    <div className="flex gap-2">
      <Button
        icon="pi pi-eye"
        rounded
        outlined
        onClick={() => navigate(`/station-details/${stationId}`)}
        className="text-blue-600"
      />
      <Button
        icon="pi pi-external-link"
        rounded
        outlined
        onClick={() =>
          window.open(`${COCHARGE_DIRECT_BASE_URL}/l/${stationId}`)
        }
        className="text-blue-600"
      />
    </div>
  );
};
